<!--
  创建排版任务飞行动效（全局单例，挂载于 bluenHome）

  监听 EventBus PAIBAN_TASK_FLY：从「创建排版任务」按钮飞到侧栏 #paiban_task_btn。
  任务数据与角标由 paibanTaskStore 在 emit 前已写入，本组件仅负责视觉反馈。
-->
<template>
  <div v-show="isVisible" class="g-paiban-task-fly">
    <div ref="cardRef" class="g-paiban-task-fly__card" :style="cardStyle">
      <i
        class="iconfont icon-jiarurenwuliebiao"
        style="color: #18a8c7; font-size: 60px; font-weight: bold"
      />
      <!-- <div class="g-paiban-task-fly__head">
        <span class="g-paiban-task-fly__dot" />
        <span class="g-paiban-task-fly__label">{{ statusText }}</span>
      </div>
      <div class="g-paiban-task-fly__batch ellipsis">{{ taskBatch }}</div>
      <div class="g-paiban-task-fly__bar">
        <div class="g-paiban-task-fly__bar-inner" />
      </div> -->
    </div>
  </div>
</template>

<script>
import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'

/** 飞行总时长（ms） */
const FLY_DURATION_MS = 680
/** 抛物线弧顶高度（px），形成「抛向侧栏」的视觉 */
const ARC_HEIGHT = 48

export default {
  name: 'GPaibanTaskFly',
  data() {
    return {
      isVisible: false,
      /** 卡片使用 fixed + transform，避免影响布局流 */
      cardStyle: {
        transform: 'translate(-9999px, -9999px) scale(1)',
        opacity: '0',
      },
      taskBatch: '',
      statusText: '等待中',
      rafId: null,
    }
  },
  mounted() {
    EventBus.$on(EventBusKey.PAIBAN_TASK_FLY, this.handleFly)
  },
  beforeDestroy() {
    EventBus.$off(EventBusKey.PAIBAN_TASK_FLY, this.handleFly)
    this.cancelAnimation()
  },
  methods: {
    /** 组件销毁或连续触发时取消未结束的帧动画 */
    cancelAnimation() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId)
        this.rafId = null
      }
    },
    /**
     * @param {Object} payload
     * @param {string} [payload.fromSelector] 起点 DOM 选择器，默认创建任务按钮
     * @param {string} [payload.toSelector] 终点 DOM 选择器，默认侧栏排版任务入口
     * @param {string} [payload.taskBatch] 飞行动效卡片上展示的批次号
     * @param {string} [payload.statusText] 飞行动效卡片上展示的状态文案
     */
    handleFly(payload = {}) {
      const fromSelector =
        payload.fromSelector || '#paiban_setting_create_task_btn'
      const toSelector = payload.toSelector || '#paiban_task_btn'
      const fromEl = document.querySelector(fromSelector)
      const toEl = document.querySelector(toSelector)
      // 弹窗未打开或侧栏未渲染时跳过，避免坐标异常
      if (!fromEl || !toEl) {
        EventBus.$emit(EventBusKey.PAIBAN_TASK_FLY_END)
        return
      }

      this.taskBatch = payload.taskBatch || ''
      this.statusText = payload.statusText || '等待中'
      this.cancelAnimation()
      this.isVisible = true

      const fromRect = fromEl.getBoundingClientRect()
      const toRect = toEl.getBoundingClientRect()
      const startX = fromRect.left + fromRect.width / 2
      const startY = fromRect.top + fromRect.height / 2
      const endX = toRect.left + toRect.width / 2
      const endY = toRect.top + toRect.height / 2
      const startScale = 1
      const endScale = 0.42

      this.cardStyle = {
        transform: `translate(${startX}px, ${startY}px) translate(-50%, -50%) scale(${startScale})`,
        opacity: '1',
      }

      const startTime = performance.now()

      const tick = (now) => {
        const raw = Math.min(1, (now - startTime) / FLY_DURATION_MS)
        // ease-out 缓动：前快后慢，贴近落入侧栏的感觉
        const eased = 1 - Math.pow(1 - raw, 3)
        const arc = Math.sin(raw * Math.PI) * ARC_HEIGHT
        const x = startX + (endX - startX) * eased
        const y = startY + (endY - startY) * eased - arc
        const scale = startScale + (endScale - startScale) * eased
        // 末段淡出，避免卡片叠在菜单文字上过于突兀
        const opacity = raw < 0.92 ? 1 : 1 - (raw - 0.92) / 0.08

        this.cardStyle = {
          transform: `translate(${x}px, ${y}px) translate(-50%, -50%) scale(${scale})`,
          opacity: String(opacity),
        }

        if (raw < 1) {
          this.rafId = requestAnimationFrame(tick)
        } else {
          this.rafId = null
          this.isVisible = false
          this.cardStyle = {
            transform: 'translate(-9999px, -9999px) scale(1)',
            opacity: '0',
          }
          EventBus.$emit(EventBusKey.PAIBAN_TASK_FLY_END)
        }
      }

      this.rafId = requestAnimationFrame(tick)
    },
  },
}
</script>

<style scoped lang="less">
/* 全屏透明层，仅承载飞行卡片，不拦截点击 */
.g-paiban-task-fly {
  position: fixed;
  inset: 0;
  z-index: 100000;
  pointer-events: none;

  &__card {
    position: fixed;
    left: 0;
    top: 0;
    width: 60px;
    height: 60px;
    border-radius: 6px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
    will-change: transform, opacity;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
  }

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #faad14;
    flex-shrink: 0;
  }

  &__label {
    font-size: 12px;
    color: #666;
  }

  &__batch {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    max-width: 100%;
  }

  &__bar {
    height: 4px;
    background: #f0f0f0;
    border-radius: 2px;
    overflow: hidden;
  }

  &__bar-inner {
    width: 0;
    height: 100%;
    background: linear-gradient(90deg, #18a8c7, #5cdbd3);
    border-radius: 2px;
  }
}
</style>
